import { NgModule } from '@angular/core'
import { CommonComponentsModule } from 'src/app/common/components/common-components.module'
import { CommonModalsModule } from 'src/app/common/modals/common-modals.module'
import { SharedModule } from 'src/app/shared/shared.module'
import { GlobalNavigationBarRoutingModule } from './global-navigation-bar-routing'
import { GlobalNavigationBarComponent } from './global-navigation-bar.component'

@NgModule({
  declarations: [GlobalNavigationBarComponent],
  imports: [SharedModule, CommonComponentsModule, CommonModalsModule, GlobalNavigationBarRoutingModule],
})
export class GlobalNavigationBarModule {}
